import React from 'react';
import Widget from 'components/Widget/Widget';
import PnLByDaysChartBody from './components/PnLByDaysChartBody';

import { metricsList } from '../components/metricsList';

const PnLByDaysChart = ({ height = 500, data, index, configuration }) => {
  return (
    <Widget
      className='w-full bg-white'
      widget_key={'PnLByDaysChart' + index}
      title={data.title}
      index={index}
      disableLevelFilter
      disableLimit
      disableStatusFilter
      default_filter={data.defaultFilter}
      configuration={configuration}
      metricsList={metricsList}
      data={data}
      load_chart={true}
      adsFilter
      adsetFilter
      campaignFilter
      showCustomDesign
      changeMetricsDesign
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <PnLByDaysChartBody height={height - 55} />
    </Widget>
  );
};

export default PnLByDaysChart;
